<template>
  <ExpedienteCreateComiteView prefix-create-path="case_file/court_resolution/"></ExpedienteCreateComiteView>
</template>

<script>
import ExpedienteCreateComiteView from './ExpedienteCreateComiteView'

export default {
  components: {
    ExpedienteCreateComiteView
  }
}
</script>
